/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  .  .  .  . .  .  . .  .
    *    .       .       .       .       .       .       .       .       .       .       .       .
    *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
    *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
    *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
    *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
    *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
    *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
    *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
    *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
    *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
    *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
    *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
    *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
    *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
    *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *
 * Copyright FortyFix(c) 2024.
 * Title: Promozioni.ts;
 * Path: ./src/environments/Modules/Promozioni.ts;
 * Description: modulo Listini vendita / scontistiche (nato da klimaitalia Customer);
 * Author: giovannibattistadellaporta;
 * Created at: 10/09/25, 16:20;
 * Updated at: 10/09/25, 16:20;
 *
 */
import {OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {BottoneAggiuntivo, CampoAggiuntivo} from "../../app/shared/models/campo-aggiuntivo";
import {ApiPathsService} from "../../app/api-paths.service";
import {ToastrService} from "ngx-toastr";

class Listino {
  id: number;
  data: string;
  data_fine: string;
  categorieObject: Prodotto_Listino[];
  prodottiObject: Prodotto_Listino[]
  tipo: "P" | "L";
}
class Prodotto_Listino{
  id: number;
  prodotto: number;
  categoria: number;
  sconto: string | number;
  sconto1: string | number;
  sconto2: string | number;
  sconto3: string | number;
  prezzo: string | number;
}

function Validate(listino: Listino, bup:Listino, toastrService: ToastrService): boolean{

  var prodottiOK = listino.prodottiObject?.every(x=>x.prodotto) ?? true;
  var prodottiScontoOK = listino.prodottiObject?.every(x=>x.prezzo || x.sconto1 || x.sconto2 || x.sconto3);
  var catOK = listino.categorieObject?.every(x=>x.categoria) ?? true;
  var catScontoOK = listino.categorieObject?.every(x=>x.sconto1 || x.sconto2 || x.sconto3);

  console.log(`Prodotti OK: ${prodottiOK}, Prodotti Sconto OK: ${prodottiScontoOK}, Categoria OK: ${catOK}, Categoria Sconto OK: ${catScontoOK}`);

  if(listino.prodottiObject?.length && !prodottiOK){
    toastrService.error("è necessario indicare il prodotto per ogni voce inserita.");
    return false;
  }
  if((listino.prodottiObject?.length && !prodottiScontoOK ) || (listino.categorieObject?.length && !catScontoOK)){
    toastrService.error("è necessario indicare lo sconto per ogni voce inserita.");
    return false;
  }
  if(listino.categorieObject?.length && !catOK){
    toastrService.error("è necessario indicare la categoria per ogni voce inserita.");
    return false;
  }

  return true;
}
function SaveListinoPromozione(listino: Listino, api: ApiPathsService, callback: (x) => void, bup: Listino, toastrService: ToastrService, type: "P" | "L" = "P") {
  listino.tipo = type;
  if(!Validate(listino,bup, toastrService)) return;
  api.ClassicPost(`/prodotti/promozione/${listino.id ? "update" : "add"}`, listino).subscribe(data => {
    AddProdotti(listino.id ? listino : Object.assign(data, {
      prodottiObject: listino.prodottiObject,
      categorieObject: listino.categorieObject
    }), api, callback, listino);
  })
}

function AddProdotti(listino: Listino, api: ApiPathsService, callback: (x) => void, bup: Listino) {
  api.ClassicPost("/prodotti/promozione/prodotti/list", {id: listino.id, page: 0, size: 10}).subscribe(
    prodottiOld => {
      var voci = [...listino?.categorieObject ?? [], ...listino?.prodottiObject ?? []];
      voci?.forEach(y => {
        var old = prodottiOld.data.find(x => x.id == y.id);
        if (old) {
          console.log("To compare: ", y, old);
        }
        if (
          y.id &&
          old &&
          old.sconto == y.sconto &&
          old.sconto1 == y.sconto1 &&
          old.sconto2 == y.sconto2 &&
          old.sconto3 == y.sconto3 &&
          old.prezzo == y.prezzo &&
          old.prodottoObject?.id == y.prodotto &&
          old.categoria == y.categoria
        ) return;
        api.ClassicPost(`/prodotti/promozione/prodotti/${y.id ? "update" : "add"}`, Object.assign({}, y, {
          id_prodotto: y.prodotto,
          id_listino: listino.id
        })).subscribe();
      })
      callback(listino);
    }
  )
}

export function ProdottiTable(customization?: CampoAggiuntivo): CampoAggiuntivo {
  return Object.assign({}, CampoAggiuntivo.TableField("Prodotti", [
      CampoAggiuntivo.SingleDropdown("Prodotto", "prodotto", "/prodotti/list", "prodotto", {
        responseHasData: true,
        parameter: [{nome: "page", value: 0}, {nome: "size", value: 10}, {nome: "tipo", value: 68}]
      }, 'col-12'),
      CampoAggiuntivo.TextField("Prezzo", "prezzo", "col-12"),
      CampoAggiuntivo.TextField("Sconto 1", "sconto1", "col-12"),
      CampoAggiuntivo.TextField("Sconto 2", "sconto2", "col-12"),
      CampoAggiuntivo.TextField("Sconto 3", "sconto3", "col-12"),
    ], 'prodottiObject', true, 'col-lg-12',
    {
      Buttons: [
        {
          nome: '',
          close: false,
          icon: 'fas fa-plus text-info',
          class: ' btn ',
          labelClass: 'text-info font-weight-bold',
          type: 'func',
          hideif: {
            func: (x) => {
              return true;
            }
          },
          func: (x, api: ApiPathsService, endFunc) => {
            console.log("x: ", x)
            x.prodottiObject = [{modifica: true, id_listino: x.id}, ...(x.prodottiObject ?? [])];
          },
          validate: (item: any, Toastr: ToastrService, api: ApiPathsService) => {
            return true
          },
        },
      ],
      azioni: [
        {func:(field, bottone: BottoneAggiuntivo, campo: CampoAggiuntivo, Oggetto: {prodottiObject: any[]}, api: ApiPathsService)=>{
            var id = Oggetto.prodottiObject.findIndex(x=>x == field)
            if(field.id){
              api.ClassicPost("/prodotti/promozione/prodotti/delete", {id: field.id}).subscribe(()=>{
                Oggetto.prodottiObject.splice(id, 1);
              })
            }else{
              Oggetto.prodottiObject.splice(id, 1);
            }
          }, icon: 'fa-trash', tooltip: 'Elimina', color: 'red'}]
    }), customization)

}

export function CategorieTable(customization?: CampoAggiuntivo): CampoAggiuntivo {
  return Object.assign({}, CampoAggiuntivo.TableField("Categorie", [
      CampoAggiuntivo.SingleDropdown("Categoria", "categoria", "/prodotti/categorie/list/list", "categoria", {
        responseHasData: false,
        parameter: []
      }, 'col-12'),
    //  CampoAggiuntivo.TextField("Prezzo", "prezzo", "col-12"),
      CampoAggiuntivo.TextField("Sconto 1", "sconto1", "col-12"),
      CampoAggiuntivo.TextField("Sconto 2", "sconto2", "col-12"),
      CampoAggiuntivo.TextField("Sconto 3", "sconto3", "col-12"),
    ], 'categorieObject', true, 'col-lg-12',
    {
      Buttons: [
        {
          nome: '',
          close: false,
          icon: 'fas fa-plus text-info',
          class: ' btn ',
          labelClass: 'text-info font-weight-bold',
          type: 'func',
          hideif: {
            func: (x) => {
              return true;
            }
          },
          func: (x, api: ApiPathsService, endFunc) => {
            console.log("x: ", x)
            x.categorieObject = [{modifica: true, id_listino: x.id}, ...(x.categorieObject ?? [])];
          },
          validate: (item: any, Toastr: ToastrService, api: ApiPathsService) => {
            return true
          },
        },
      ],
      azioni: [
        {func:(field, bottone: BottoneAggiuntivo, campo: CampoAggiuntivo, Oggetto: {categorieObject: any[]}, api: ApiPathsService)=>{
          var id = Oggetto.categorieObject.findIndex(x=>x == field)
          if(field.id){
            api.ClassicPost("/prodotti/promozione/prodotti/delete", {id: field.id}).subscribe(()=>{
              Oggetto.categorieObject.splice(id, 1);
            })
          }else{
            Oggetto.categorieObject.splice(id, 1);
          }
          }, icon: 'fa-trash', tooltip: 'Elimina', color: 'red'}
      ]
    }), customization)

}

function ListinoToCat():OggettoConfig{
  return {
    Capacita: [],
    Id: "promozionicat",
    listTitle: "Promozioni",
    RestRoute: "/anagrafica/clienti/promozioni",
    fullListRoute:"/anagrafica/clienti/promozioni",
    listIsGet:true,
    HasGet:false,
    ListMap:(data)=>{
      var result = data.map(item=>{
        var text = "";
        item.listiniObject?.forEach((x,i)=>{
          text += `${x.nome} dal ${item.dal[i]} al ${item.al[i]}`;
        });
        item.ListiniText = text
        return item
      });
      console.log(result)
      return result;

    },
    ListResponseHasData: false,
    GetResponseHasData: true,
    ListDefaultFilter: {},
    MenuItems: [
      {
        path: "/shared/dynamiclist/promozionicat",
        title: "Listini -> Categorie Commerciali",
        icon: "fas fa-list",
        class: "",
        capacita: [],
        notruoliOperativi: ["K", "AG"],
      },
    ],
    Headers: [
      {nome: 'Categoria Commerciale', oggetti: ['nome'], inputType: 'text'},
      {nome: 'Listini', oggetti: ['ListiniText'], inputType: 'text'}
    ],
    campi:[
      {nome: 'Categoria Commerciale', oggetti: ['nome'], inputType: 'text', class:'col-12'},
      CampoAggiuntivo.SingleDropdown(
        "Listini",
        "listini",
        "/prodotti/promozione/list",
        "nome",
        {
          url: "/prodotti/promozione/list",
          parameter: [{nome: "page", value: 1}, {nome: "size", value: 2000}],
          responseHasData: true,
          settings: {
            singleSelection: false,
            closeDropDownOnSelection: false,
            singleOutput: false,
            idField: 'id',
            textField: 'nome',
            allowSearchFilter: true,
          },
        },
        "col-12"
      )
    ]
  }
}

export function ListinoPromozione( type: "P" | "L" = "P"): OggettoConfig {
  return {
    HasAddList: {},
    Capacita: [],
    Id: type == "P" ?  "promozione" : "listino",
    listTitle: type == "P" ?"Listini Promo" : "Listini Scontistiche",
    RestRoute: "/prodotti/promozione",
    ListResponseHasData: true,
    GetResponseHasData: true,
    ListDefaultFilter: { tipo: type },
    // OnSaveMap: (x) => { { return x } },
    customSave: (x: Listino, api, callback, bup, toastrService) => {
      SaveListinoPromozione(x, api, callback, bup,toastrService, type);
    },
    MenuItems: [
      {
        path: "/shared/dynamiclist/promozione",
        title: "Listini Promo",
        icon: "fas fa-list",
        class: "",
        capacita: [],
        notruoliOperativi: ["K", "AG"],
      },
      {
        path: "/shared/dynamiclist/listino",
        title: "Listini Scontistiche",
        icon: "fas fa-list",
        class: "",
        capacita: [],
        notruoliOperativi: ["K", "AG"],
      },
    ],
    campi: [
      {
        nome: 'Nome',
        oggetti: ['nome'],
        modificabile: true,
        inputType: 'text',
        required: true,
        class: 'col-lg-12'
      },
      {
        nome: 'Data Inizio',
        oggetti: ['data'],
        modificabile: true,
        required: true,
        inputType: 'date',
        class: 'col-lg-6'
      },
      {
        nome: 'Data fine',
        oggetti: ['data_fine'],
        modificabile: true,
        inputType: 'date',
        class: 'col-lg-6'
      },
      ProdottiTable({
        url: "/prodotti/promozione/prodotti/list",
        // filter: (data) => {
        //   console.log(data);
        //   var cat = [...data?.filter(x => x.prodottoObject)?? []];
        //   console.log("Prod: ", cat);
        //   return cat
        // },
        parameter: [{nome: "page", value: 0}, {nome: "size", value: 200}, {nome: "id", parameter: "id"}, {nome: "tipo", value: "P"}],
        hideif: {func: (x) => x.id}
      }),
      ProdottiTable({
        hideif: {func: (x) => !x.id}
      }),
      CategorieTable({
        hideif: {func: (x) => !x.id}
      }),
      CategorieTable({
        // filter: (data) => {
        //   console.log(data);
        //   var cat = [...data?.filter(x => x.categoria)?? []];
        //   console.log("Cat: ", cat);
        //   return cat
        // },
        url: "/prodotti/promozione/prodotti/list",
        parameter: [{nome: "page", value: 0}, {nome: "size", value: 200}, {nome: "id", parameter: "id"}, {nome: "tipo", value: "C"}],
        hideif: {func: (x) => x.id}
      }),

    ],
    Azioni: [
      {
        nome: 'Elimina',
        close: true,
        class: ' btn ',
        labelClass: 'ml-1 text-danger font-weight-bold',
        type: 'POST',
        restRoute: '/prodotti/promozione/delete',
        preAlert: 'Sei sicuro di voler eliminare questo elemento?',
        capacita: ['gestione-mansione'],
        icon: 'fas fa-trash text-danger',
        hideif: {fieldnotexist: 'id'},
        placeholder: 'Elimina',
        successMex: 'Elemento eliminato con successo',
        parameter: [{nome: "id", parameter: 'id'}]
      }
    ],
    Headers: [
      {nome: 'Nome', oggetti: ['nome'], inputType: 'text'},
      {nome: 'Data', oggetti: ['data'], inputType: 'date'},
      {nome: 'Data Fine', oggetti: ['data_fine'], inputType: 'date'},
    ],
    Filters: [],
  }
}

export var Promozioni = () => {
  var env: any = {
    Cruds: [ListinoPromozione("P"), ListinoPromozione("L"), ListinoToCat()],
    Menu: [...ListinoPromozione().MenuItems, ...ListinoToCat().MenuItems],
    ClientiAddOn: {
      CampiAggiuntivi: [
        {
          modificabile: true,
          nome: 'Listini',
          oggetti: ['listini'],
          inputType: 'singleDropdown',
          source: '/prodotti/promozione/list',
          parameter: [{nome: "page", value: 1}, {nome: "size", value: 2000}],
          responseHasData: true,
          OutputField: 'listini',
          internalOutput: 'listiniObject',
          placeholder: 'Seleziona',
          OnChange: 'OnlistiniChange',
          hideif: {hasRoles: ['AG', 'K']},
          settings: {
            singleSelection: false,
            closeDropDownOnSelection: false,
            singleOutput: false,
            idField: 'id',
            textField: 'nome',
            allowSearchFilter: true,
          },
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3',
          visibleifProhibited: true
        }
      ]
    },
    Modules: {
      "promozioni": true,
    }
  };
  return env;
}
